// extracted by mini-css-extract-plugin
module.exports = {"single":"_2c06dW","logo":"_3QVJjT","selector":"_14YvcB","primeLogo":"_2lrSFx"};